import type { MetaFunction } from '@remix-run/node';

import { isTipJarLoaderData } from '~/interfaces/tip_jar';
import getMergedMetaData from '~/utils/getMergedMetaData';

export const tipJarMeta: MetaFunction = ({ data, matches }) => {
  if (!isTipJarLoaderData(data)) return [];

  const { tipJar, pageUrl, pageTitle, pageDescription } = data;
  const bannerOverrides = tipJar.banner_url
    ? { 'og:image': tipJar.banner_url, 'twitter:image': tipJar.banner_url }
    : {};

  return getMergedMetaData({
    matches,
    canonicalUrl: pageUrl,
    overrides: {
      title: pageTitle,
      description: pageDescription,
      'og:url': pageUrl,
      'og:title': tipJar.title,
      'og:description': pageDescription,
      'twitter:url': pageUrl,
      'twitter:title': tipJar.title,
      'twitter:description': pageDescription,
      ...bannerOverrides,
    },
  });
};
